export class Diligence {
    get id() {
        return this.diligenceState.id;
    }
    get diligenceNumber() {
        return this.diligenceState.diligenceNumber;
    }
    get entryDate() {
        return this.diligenceState.entryDate;
    }
    get instructorId() {
        return this.diligenceState.instructorId;
    }
    get secretaryId() {
        return this.diligenceState.secretaryId;
    }
    get courtId() {
        return this.diligenceState.courtId;
    }
    get diligenceTypeId() {
        return this.diligenceState.diligenceTypeId;
    }
    get subDiligenceTypeId() {
        return this.diligenceState.subDiligenceTypeId;
    }
    get userId() {
        return this.diligenceState.userId;
    }
    get proceedingsNumber() {
        return this.diligenceState.proceedingsNumber;
    }
    get coords() {
        return this.diligenceState.coords;
    }
    set diligenceNumber(diligenceNumber) {
        this.diligenceState.diligenceNumber = diligenceNumber;
    }
    set entryDate(entryDate) {
        this.diligenceState.entryDate = entryDate;
    }
    set instructorId(instructorId) {
        this.diligenceState.instructorId = instructorId;
    }
    set secretaryId(secretaryId) {
        this.diligenceState.secretaryId = secretaryId;
    }
    set courtId(courtId) {
        this.diligenceState.courtId = courtId;
    }
    set diligenceTypeId(diligenceTypeId) {
        this.diligenceState.diligenceTypeId = diligenceTypeId;
    }
    set subDiligenceTypeId(subDiligenceTypeId) {
        this.diligenceState.subDiligenceTypeId = subDiligenceTypeId;
    }
    set userId(userId) {
        this.diligenceState.userId = userId;
    }
    set proceedingsNumber(proceedingsNumber) {
        this.diligenceState.proceedingsNumber = proceedingsNumber;
    }
    set coords(coords) {
        this.diligenceState.coords = coords;
    }
    constructor(diligenceState) {
        this.diligenceState = diligenceState;
    }
    getState() {
        return this.diligenceState;
    }
}
